import RelativeTimestampBadge from '@common-components/relative-timestamp-badge/relative-timestamp-badge';
import { UserMessage } from '@bt-common/schemas/bt/user-message';
import { EffectiveMessageStatus } from '@/common/components/message-status/message-status-config';

interface ScheduledMessageDateBadgeProps {
  dueDate?: string;
  status?: EffectiveMessageStatus;
  error?: any;
  message?: UserMessage; // Full message object for computing effective status (e.g., expired)
}

const ScheduledMessageDateBadge = ({ dueDate, status, error, message }: ScheduledMessageDateBadgeProps) => {
  return <RelativeTimestampBadge dueDate={dueDate} compact={false} status={status} error={error} message={message} />;
};

export default ScheduledMessageDateBadge;